/**
 * mhub-api tags `User.Groups` as `json:"groups,omitempty"`, so a staff whose
 * user holds no group at all comes back from `/staffs/` with no `groups` key —
 * not an empty array. The staff screens all treat it as an array, so without
 * this the Access Role dropdown (and the Update button itself) throws on the
 * users who most need a role, and the change is silently dropped. MS-6597.
 *
 * Returns the staff unchanged unless it is missing `user.groups`, in which case
 * a shallow copy carrying an empty array is returned.
 */
// eslint-disable-next-line import/prefer-default-export
export const withUserGroups = (staff) => {
  if (!staff || !staff.user || staff.user.groups) {
    return staff;
  }
  return { ...staff, user: { ...staff.user, groups: [] } };
};



// WEBPACK FOOTER //
// ./src/utils/staff.js